export default {
  "app_label": "architect",
  "model_name": "architect",
  "pagination": true,
  "columns": [
    {
      "name": "name",
      "label": "Name",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "str",
      "ellipsis": true,
      // "search": true,
      "sort": true
    },
    {
      "name": "created",
      "label": "Created",
      "data_type": "datetime",
      "sort": true,
    },
    {
      "name": "modified",
      "label": "Modified",
      "data_type": "datetime",
      "sort": true,
    },
  ],
  "filter_by": [],
  "export_import": null
}